


















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class CardAuth extends Vue {
  @Prop() title?: string;
  @Prop() description?: string;
}
